<template>
  <div class="preview configs bluerect">
    <div v-if="file.type == 'img' || file.type == 'pdf'" class="w2dpreview">
      <div class="contentid">
        <span v-if="contentId">{{ contentId }}</span>
        <p v-if="publishDate">pubblicato il {{ publishDate }}</p>
      </div>
      <div>
        <span class="destination">&gt;&gt; {{ destination }}</span>
      </div>
      <div>
        <h1 class="headline" v-html="file.headline" />
      </div>
      <img class="thumbnailpreview" v-bind:src="file.imgsrc" />
      <div class="caption" v-html="file.body" />
    </div>
    <div
      v-else-if="file.type == 'url' || file.type == 'any'"
      class="w2dpreview"
    >
      <div class="contentid">
        <span v-if="contentId">{{ contentId }}</span>
        <p v-if="publishDate">pubblicato il {{ publishDate }}</p>
      </div>

      <div>
        <span class="destination">&gt;&gt; {{ destination }}</span>
      </div>
      <div>
        <h1 class="headline" v-html="file.headline" />
      </div>
      <div>
        <h2 class="lead" v-html="file.lead" />
      </div>
      <template v-if="validUrl">
        <img class="thumbnailpreview" v-bind:src="file.imgsrc" />
      </template>
      <div class="body" v-html="file.body" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import profileService from "../services/profileService";

export default {
  name: "preview",
  components: {},
  props: {
    file: Object /*{
      type: String,
      imgsrc: String,
      headline: String,
      body: String,
      dest: String,
      contentId: String,
      published: Date
    }
    */
  },
  data: function () {
    return {};
  },
  computed: {
    validUrl: function () {
      const f = this.file || {};
      const src = f.imgsrc;
      if (src !== undefined) {
        return !src.endsWith("undefined");
      }
      return false;
    },
    destination: function () {
      const f = this.file || {};
      if (f.dest) {
        if (this.destOptions && this.destOptions[f.dest]) {
          return this.destOptions[f.dest];
        }
        console.log(`${f.dest} (unconfigured in the profile)`);
        return f.dest;
      }
      return "";
    },
    contentId: function () {
      const f = this.file || {};
      return f.contentId;
    },
    publishDate: function () {
      const f = this.file || {};
      const t = f.published;
      if (t !== undefined) {
        return (
          moment(t).format("YYYY-MM-DD hh:mm:ss") +
          " (" +
          moment(t).fromNow() +
          ")"
        );
      } else {
        return undefined;
      }
    }
  },
  methods: {
    getProfileService() {
      return new profileService({
        profile: this.profile,
        user: this.user
      });
    }
  },
  mounted: function () {
    // clear destinations
    this.destOptions = {};

    this.user = this.$store.getters.user;
    this.profile = this.$store.getters.profile;

    // calculate new destinations based on the profile
    this.getProfileService().processDestinations((k, dest) => {
      this.destOptions[k] = dest.name;
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w2dpreview {
  height: 100%;
  white-space: initial;
  overflow: auto;
  zoom: 0.5;
}

.centeringparent {
  display: flex;
  justify-content: center;
  align-items: center;
}
img.thumbnailpreview {
  padding: 0.5em;
}
div.preview .destination {
  font-size: 1.4em;
  font-weight: 700;
}
div.preview .contentid {
  font-size: 1.4em;
}
div.caption,
div.body {
  font-size: 1.8em;
}
h1.headline {
  font-size: 2em;
}
h2.lead {
  font-size: 1.8em;
}
</style>
